import './main.scss';

import { loadComponents } from '@opten/gin-tonic/helpers/components';
import { SidebarComponent } from './components/sidebar';
//import { TipsComponent } from './components/tips';
import { MapComponent } from './components/map';

loadComponents(SidebarComponent);

function loadElemIfReady(selector: string, callback) {
	const timer = setInterval(() => {
		const elem = document.querySelector(selector);
		if (elem != null) {
			clearInterval(timer);
			callback(elem);
		}
	}, 500);
}

/*
window.loadTips = function () {
	loadElemIfReady('.js-tips', (elem) => new TipsComponent(elem));
};
*/
// load google maps

let googleMapsLoaded = false;
let mapContentLoaded = false;
let mapDotNetReference = null;

window.loadMap = (dotNetReference) => {
	console.log('loadMap...');
	mapContentLoaded = true;
	mapDotNetReference = dotNetReference;
	if (googleMapsLoaded) {
		console.log('googleMapsLoaded!');
		loadElemIfReady(
			'.js-map',
			(elem) => new MapComponent(elem, mapDotNetReference)
		);
	}
};

window.googleMapsLoaded = () => {
	console.log('googleMapsloaded...');
	googleMapsLoaded = true;
	if (mapContentLoaded) {
		console.log('mapContentLoaded!');
		loadElemIfReady(
			'.js-map',
			(elem) => new MapComponent(elem, mapDotNetReference)
		);
	}
};
